// extracted by mini-css-extract-plugin
export default {"text-color":"#000000","textColor":"#000000","text-color-light":"#707070","textColorLight":"#707070","label":"xxKYC"};